import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  height?: number | string;
  width?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon = '📄',
  title,
  description,
  height = 200,
  width = '100%'
}) => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        justifyContent: 'center', 
        alignItems: 'center', 
        height: height,
        width: width,
        color: 'text.secondary',
        textAlign: 'center',
        border: '1px dashed',
        borderColor: 'divider',
        borderRadius: 2,
        mt: 2
      }}
    >
      <Typography variant="body2" gutterBottom sx={{ fontWeight: 500 }}>
        {icon} {title}
      </Typography>
      {description && (
        <Typography variant="caption" sx={{ lineHeight: 1.4 }}>
          {description}
        </Typography>
      )}
    </Box>
  );
};

export default EmptyState; 